// Bilingual content dictionary for Bendito Tattoo
export const translations = {
  en: {
    nav: {
      work: "Work",
      artists: "Artists",
      studio: "Studio",
      quote: "Get a Quote",
      blog: "Blog",
      faq: "FAQ",
      book: "Book on WhatsApp",
    },
    hero: {
      eyebrow: "Playa del Carmen · Quintana Roo",
      title1: "Your Story.",
      title2: "Permanently Inked in Paradise.",
      sub: "Custom Tattoos & Piercings in Playa del Carmen — by artists who live for their craft.",
      ctaPrimary: "Book a Free Consultation",
      ctaSecondary: "View Our Work",
      scroll: "Scroll",
    },
    trust: {
      a: "We speak English & Spanish",
      b: "Sterile equipment · Single-use needles",
      c: "Open 7 days · 10 AM to Midnight",
      d: "Walk-ins welcome",
    },
    portfolio: {
      eyebrow: "Selected Work",
      title: "Our Work",
      sub: "A glimpse of what comes out of our studio. Tap any piece to enlarge.",
      filters: {
        all: "All",
        blackwork: "Blackwork",
        fineLine: "Fine Line",
        fullColor: "Full Color",
        traditional: "Traditional",
        mayan: "Mayan & Cultural",
        tribal: "Tribal & Maori",
        geometric: "Geometric",
        realism: "Realism",
        neoTraditional: "Neo Traditional",
        bioOrganic: "Bio-Organic",
        piercings: "Piercings",
      },
      more: "More work on Instagram",
      lightboxAlt: "Tattoo work by Bendito Tattoo",
    },
    artists: {
      eyebrow: "Meet the Team",
      title: "The Artists",
      sub: "Six voices. One studio. Pick the artist whose work speaks to you.",
      bookWith: "Book with",
      languages: "Languages",
      specialties: "Specialties",
      experience: "Experience",
      comingSoon: "Profile coming soon",
      eeme: {
        title: "Tattoo Artist",
        specialties: "Fine Line · Micro Realism",
        languages: "Spanish · English",
        bio: "Specialist in fine line and micro realism. EEME transforms your ideas into delicate, precise artwork that tells your story on skin.",
      },
      may: {
        title: "Tattoo Artist",
        specialties: "Fine Line",
        languages: "Spanish · English",
        experience: "9+ years",
        bio: "Specialist in fine line with over 9 years of experience. Delicate, precise and personalized tattoos created with a clean aesthetic and obsessive attention to detail.",
      },
      tyson: {
        title: "Piercer & Body Modification Artist",
        specialties: "Piercings · Scarification · Implants · Split Tongue",
        languages: "Spanish",
        experience: "8 years",
        bio: "8 years mastering the art of body modification. From precision piercings to advanced mods like scarification and split tongue — Tyson pushes boundaries with safety and expertise.",
      },
      alvaro: {
        title: "Tattoo Artist",
        specialties: "Blackwork · Traditional · Tribal · Maori · Geometric",
        languages: "Spanish · Basic English",
        experience: "10 years",
        bio: "Uruguayan artist with 10 years of experience. Alvaro is a master of bold, large-scale work — from intricate Maori and tribal pieces to sacred geometry and blackwork that commands attention.",
      },
      avelino: {
        title: "Tattoo Artist",
        specialties: "Black & Grey · Realism · Full Color · Neo Traditional · Blackwork · Geometric · Oriental · Anime",
        languages: "Spanish",
        experience: "6 years",
        bio: "Argentine artist with 6 years of experience. Avelino specializes in black and grey realism, bringing portraits and concepts to life with stunning depth and detail.",
      },
      ezzer: {
        title: "Tattoo Artist",
        specialties: "Neo Traditional · Traditional · Japanese · Blackwork · Bio-Organic",
        languages: "Spanish · English",
        experience: "9 years",
        bio: "Mexican artist with 9 years of experience. Ez'zer masters the fusion of neo traditional and Japanese styles, creating bold, vibrant pieces with deep cultural roots and organic flow.",
      },
    },
    studio: {
      eyebrow: "Our Space",
      title: "The Space",
      sub: "A space designed for art, built for safety. Every surface sanitized, every needle single-use, every instrument autoclave-sterilized. Your body deserves nothing less.",
      badges: {
        a: "Autoclave Sterilization",
        b: "Single-Use Needles",
        c: "Hospital-Grade Disinfection",
        d: "Licensed Facility",
      },
    },
    how: {
      eyebrow: "The Process",
      title: "How It Works",
      sub: "Four steps from idea to ink. No surprises, no pressure.",
      steps: [
        {
          n: "01",
          title: "Send Your Idea",
          body: "Message us on WhatsApp with your design, reference photos, size and placement.",
        },
        {
          n: "02",
          title: "Free Consultation",
          body: "We'll discuss your vision, suggest improvements, and give you a quote.",
        },
        {
          n: "03",
          title: "Book Your Date",
          body: "Pick the day that works for you. Walk-ins also welcome.",
        },
        {
          n: "04",
          title: "Get Inked",
          body: "Relax, enjoy the vibe, and leave with art that lasts forever.",
        },
      ],
      highlight:
        "Planning your trip to Playa del Carmen? Book before you arrive — we'll have your custom design ready when you land.",
      cta: "Start Your Consultation",
    },
    quote: {
      eyebrow: "Free · No Obligation",
      title: "Get a Free Quote",
      sub: "Every tattoo is unique — tell us about yours and we'll give you a personalized quote within hours.",
      service: "Service type",
      services: { tattoo: "Tattoo", piercing: "Piercing", bodyMod: "Body Mod" },
      style: "Style",
      styles: ["Fine Line", "Micro Realism", "Blackwork", "Traditional", "Tribal & Maori", "Geometric", "Mayan & Cultural", "Other"],
      size: "Size",
      sizes: {
        s: "5 × 5 cm",
        m: "10 × 10 cm",
        l: "15 × 15 cm",
        xl: "20 × 20 cm",
      },
      placement: "Placement",
      placements: [
        "Arm — forearm",
        "Arm — upper",
        "Arm — full sleeve",
        "Leg — thigh",
        "Leg — calf",
        "Back",
        "Chest",
        "Ribs",
        "Hand / Finger",
        "Neck",
        "Foot",
        "Other",
      ],
      artist: "Preferred artist",
      artistOptions: { any: "No preference", eeme: "EEME", may: "May", tyson: "Tyson", alvaro: "Alvaro", avelino: "Avelino", ezzer: "Ez'zer" },
      when: "When",
      whenOptions: { now: "I'm already in Playa", arriving: "Arriving on...", exploring: "Just exploring" },
      whenDate: "Arrival date",
      name: "Your name",
      submit: "Send to WhatsApp",
      sending: "Sending...",
      note: "We typically respond within 1 hour during business hours.",
      success: "Opening WhatsApp with your details...",
      error: "Something went wrong. Please try again or message us directly.",
    },
    reviews: {
      eyebrow: "Trusted by travelers & locals",
      title: "What Our Clients Say",
      sub: "Honest words from the people who've sat in our chairs.",
      leave: "Leave us a review on Google",
      items: [
        {
          quote:
            "Came on vacation, left with the most beautiful fine line tattoo of my life. EEME is unbelievably talented.",
          name: "Sarah M.",
          country: "🇺🇸 USA",
          stars: 5,
        },
        {
          quote:
            "Tyson did my ear piercing with incredible precision. Professional, clean, and very kind. 100% recommended.",
          name: "Lucía R.",
          country: "🇲🇽 MX",
          stars: 5,
        },
        {
          quote:
            "Booked from Canada before our trip. Walked in on day 3, walked out with a custom piece I'll have forever. These people genuinely care.",
          name: "Jordan T.",
          country: "🇨🇦 CA",
          stars: 5,
        },
        {
          quote:
            "Got a full sleeve started here on vacation. The geometric work is insane — clean lines, perfect symmetry. Already planning my next trip to finish it.",
          name: "Dylan K.",
          country: "🇺🇸 USA",
          stars: 5,
        },
      ],
    },
    aftercare: {
      eyebrow: "Healing in the tropics",
      title: "Tattoo Aftercare in Paradise",
      sub: "Getting inked in a tropical paradise? Here's how to keep it perfect.",
      note: "We'll give you a detailed aftercare guide after your session.",
      items: [
        { title: "Avoid direct sun", body: "Keep your fresh tattoo out of direct sunlight for 2–3 weeks." },
        { title: "No pool, ocean, or cenotes", body: "Skip swimming for 14 days to prevent infection and fading." },
        { title: "Moisturize daily", body: "Apply a thin layer of fragrance-free moisturizer 2–3 times a day." },
        { title: "Don't pick or scratch", body: "Let your skin heal naturally. Itching is part of the process." },
        { title: "Wear loose clothing", body: "Breathable fabrics over the area help everything heal cleaner." },
      ],
    },
    location: {
      eyebrow: "Find Us",
      title: "Find Us",
      sub: "In the heart of Playa del Carmen, walking distance from 5th Avenue.",
      address: "Playa del Carmen, Quintana Roo, Mexico",
      hours: "Monday — Sunday · 10 to 00",
      directions: "Get Directions",
    },
    faq: {
      eyebrow: "Questions?",
      title: "Questions?",
      items: [
        {
          q: "Is it safe to get a tattoo in Mexico?",
          a: "Absolutely. We follow international hygiene standards. All needles are single-use, all equipment is autoclave-sterilized, and our studio meets health department requirements.",
        },
        {
          q: "Do you speak English?",
          a: "Yes! Our team speaks English and Spanish. Communication is never a problem.",
        },
        {
          q: "How do I book?",
          a: "Just message us on WhatsApp! Send your idea, reference images, and preferred dates. We'll take care of the rest.",
        },
        {
          q: "Do you take walk-ins?",
          a: "Yes! Walk-ins are welcome subject to availability. For guaranteed slots, book ahead via WhatsApp.",
        },
        {
          q: "What payment methods do you accept?",
          a: "Cash (MXN and USD), credit and debit cards.",
        },
        {
          q: "Can I book before my trip?",
          a: "Absolutely — we recommend it! Book in advance and we'll have your custom design ready when you arrive.",
        },
        {
          q: "What about swimming or the beach after my tattoo?",
          a: "We recommend avoiding pools, ocean, and cenotes for 14 days. Plan your tattoo session accordingly — ideally near the end of your trip.",
        },
        {
          q: "Do you do piercings and body modifications?",
          a: "Yes! Tyson is our specialist with 8 years of experience in piercings, scarification, subdermal implants, and more.",
        },
      ],
    },
    footer: {
      tagline: "Custom tattoos, piercings & body modifications in Playa del Carmen.",
      quickLinks: "Explore",
      contact: "Contact",
      hours: "Open 7 days · 10 to 00",
      rights: "All rights reserved.",
      builtBy: "Website by Elevyte",
      followArtists: "Follow the artists",
    },
    mobile: { quote: "Get a Quote", whatsapp: "WhatsApp" },
  },

  es: {
    nav: {
      work: "Trabajos",
      artists: "Artistas",
      studio: "Estudio",
      quote: "Cotizar",
      blog: "Blog",
      faq: "Preguntas",
      book: "Reserva por WhatsApp",
    },
    hero: {
      eyebrow: "Playa del Carmen · Quintana Roo",
      title1: "Tu Historia.",
      title2: "Tatuada en el Paraíso.",
      sub: "Tatuajes Personalizados & Piercings en Playa del Carmen — artistas que viven por su arte.",
      ctaPrimary: "Reserva una Consulta Gratis",
      ctaSecondary: "Ver Nuestro Trabajo",
      scroll: "Desliza",
    },
    trust: {
      a: "Hablamos Inglés y Español",
      b: "Equipo estéril · Agujas de un solo uso",
      c: "Abierto 7 días · 10 AM a Medianoche",
      d: "Aceptamos walk-ins",
    },
    portfolio: {
      eyebrow: "Trabajos seleccionados",
      title: "Nuestro Trabajo",
      sub: "Un vistazo a lo que sale de nuestro estudio. Toca cualquier pieza para ampliarla.",
      filters: {
        all: "Todos",
        blackwork: "Blackwork",
        fineLine: "Línea Fina",
        fullColor: "A Todo Color",
        traditional: "Tradicional",
        mayan: "Maya y Cultural",
        tribal: "Tribal y Maori",
        geometric: "Geométrico",
        realism: "Realismo",
        neoTraditional: "Neo Tradicional",
        bioOrganic: "Bioorgánico",
        piercings: "Piercings",
      },
      more: "Más trabajos en Instagram",
      lightboxAlt: "Trabajo de Bendito Tattoo",
    },
    artists: {
      eyebrow: "Conoce al equipo",
      title: "Los Artistas",
      sub: "Seis voces. Un estudio. Elige al artista cuyo trabajo te hable.",
      bookWith: "Reserva con",
      languages: "Idiomas",
      specialties: "Especialidades",
      experience: "Experiencia",
      comingSoon: "Perfil próximamente",
      eeme: {
        title: "Tatuadora",
        specialties: "Línea Fina · Micro Realismo",
        languages: "Español · Inglés",
        bio: "Especialista en línea fina y micro realismo. EEME transforma tus ideas en piezas delicadas y precisas que cuentan tu historia en la piel.",
      },
      may: {
        title: "Tatuador",
        specialties: "Línea Fina",
        languages: "Español · Inglés",
        experience: "9+ años",
        bio: "Especialista en línea fina con más de 9 años de experiencia. Tatuajes delicados, precisos y personalizados creados con una estética limpia y atención obsesiva al detalle.",
      },
      tyson: {
        title: "Piercer & Body Modification",
        specialties: "Piercings · Escarificación · Implantes · Lengua Bífida",
        languages: "Español",
        experience: "8 años",
        bio: "8 años dominando el arte de la modificación corporal. Desde piercings de precisión hasta modificaciones avanzadas como escarificación y lengua bífida — Tyson lleva los límites con seguridad y experiencia.",
      },
      alvaro: {
        title: "Tatuador",
        specialties: "Blackwork · Tradicional · Tribal · Maori · Geométrico",
        languages: "Español · Inglés básico",
        experience: "10 años",
        bio: "Artista uruguayo con 10 años de experiencia. Alvaro es un maestro del trabajo a gran escala — desde piezas Maori y tribales hasta geometría sagrada y blackwork que impone presencia.",
      },
      avelino: {
        title: "Tatuador",
        specialties: "Black & Grey · Realismo · Full Color · Neo Tradicional · Blackwork · Geométrico · Oriental · Anime",
        languages: "Español",
        experience: "6 años",
        bio: "Artista argentino con 6 años de experiencia. Avelino se especializa en realismo black and grey, dando vida a retratos y conceptos con profundidad y detalle impresionantes.",
      },
      ezzer: {
        title: "Tatuador",
        specialties: "Neo Tradicional · Tradicional · Japonés · Blackwork · Bioorgánico",
        languages: "Español · Inglés",
        experience: "9 años",
        bio: "Artista mexicano con 9 años de experiencia. Ez'zer domina la fusión del neo tradicional y el estilo japonés, creando piezas vibrantes y audaces con raíces culturales profundas y flujo orgánico.",
      },
    },
    studio: {
      eyebrow: "Nuestro espacio",
      title: "El Espacio",
      sub: "Un espacio diseñado para el arte, construido para tu seguridad. Cada superficie sanitizada, cada aguja de un solo uso, cada instrumento esterilizado en autoclave. Tu cuerpo merece lo mejor.",
      badges: {
        a: "Esterilización en Autoclave",
        b: "Agujas de un Solo Uso",
        c: "Desinfección Hospitalaria",
        d: "Establecimiento Licenciado",
      },
    },
    how: {
      eyebrow: "El proceso",
      title: "Cómo Funciona",
      sub: "Cuatro pasos de la idea a la tinta. Sin sorpresas, sin presión.",
      steps: [
        {
          n: "01",
          title: "Mándanos tu idea",
          body: "Escríbenos por WhatsApp con tu diseño, fotos de referencia, tamaño y ubicación.",
        },
        {
          n: "02",
          title: "Consulta gratis",
          body: "Charlamos sobre tu visión, sugerimos mejoras y te damos una cotización.",
        },
        {
          n: "03",
          title: "Reserva tu fecha",
          body: "Elige el día que te funcione. También aceptamos walk-ins.",
        },
        {
          n: "04",
          title: "Tatúate",
          body: "Relájate, disfruta el ambiente y sal con arte que dura para siempre.",
        },
      ],
      highlight:
        "¿Planeando tu viaje a Playa del Carmen? Reserva antes de llegar — tendremos tu diseño listo cuando aterrices.",
      cta: "Empieza tu Consulta",
    },
    quote: {
      eyebrow: "Gratis · Sin compromiso",
      title: "Cotiza Gratis",
      sub: "Cada tatuaje es único — cuéntanos sobre el tuyo y te damos una cotización personalizada en horas.",
      service: "Tipo de servicio",
      services: { tattoo: "Tatuaje", piercing: "Piercing", bodyMod: "Body Mod" },
      style: "Estilo",
      styles: ["Línea Fina", "Micro Realismo", "Blackwork", "Tradicional", "Tribal y Maori", "Geométrico", "Maya y Cultural", "Otro"],
      size: "Tamaño",
      sizes: {
        s: "5 × 5 cm",
        m: "10 × 10 cm",
        l: "15 × 15 cm",
        xl: "20 × 20 cm",
      },
      placement: "Ubicación",
      placements: [
        "Brazo — antebrazo",
        "Brazo — superior",
        "Brazo — manga completa",
        "Pierna — muslo",
        "Pierna — pantorrilla",
        "Espalda",
        "Pecho",
        "Costillas",
        "Mano / Dedo",
        "Cuello",
        "Pie",
        "Otro",
      ],
      artist: "Artista preferido",
      artistOptions: { any: "Sin preferencia", eeme: "EEME", may: "May", tyson: "Tyson", alvaro: "Alvaro", avelino: "Avelino", ezzer: "Ez'zer" },
      when: "Cuándo",
      whenOptions: { now: "Ya estoy en Playa", arriving: "Llego el...", exploring: "Solo explorando" },
      whenDate: "Fecha de llegada",
      name: "Tu nombre",
      submit: "Enviar a WhatsApp",
      sending: "Enviando...",
      note: "Normalmente respondemos en menos de 1 hora durante horario de atención.",
      success: "Abriendo WhatsApp con tus datos...",
      error: "Algo salió mal. Inténtalo de nuevo o escríbenos directamente.",
    },
    reviews: {
      eyebrow: "Confiado por viajeros y locales",
      title: "Lo Que Dicen Nuestros Clientes",
      sub: "Palabras honestas de personas que se han sentado en nuestras sillas.",
      leave: "Déjanos una reseña en Google",
      items: [
        {
          quote:
            "Vine de vacaciones y me fui con el tatuaje de línea fina más hermoso de mi vida. EEME tiene un talento increíble.",
          name: "Sarah M.",
          country: "🇺🇸 USA",
          stars: 5,
        },
        {
          quote:
            "Tyson hizo mi piercing en la oreja con una precisión increíble. Profesional, limpio y muy amable. 100% recomendado.",
          name: "Lucía R.",
          country: "🇲🇽 MX",
          stars: 5,
        },
        {
          quote:
            "Reservé desde Canadá antes del viaje. Llegué el día 3 y salí con una pieza personalizada para siempre. Realmente se preocupan.",
          name: "Jordan T.",
          country: "🇨🇦 CA",
          stars: 5,
        },
        {
          quote:
            "Me hice un sleeve geométrico en vacaciones. El trabajo es una locura — líneas limpias, simetría perfecta. Ya estoy planeando volver para terminarlo.",
          name: "Dylan K.",
          country: "🇺🇸 USA",
          stars: 5,
        },
      ],
    },
    aftercare: {
      eyebrow: "Cicatrizar en el trópico",
      title: "Cuidados del Tatuaje en el Paraíso",
      sub: "¿Te tatúas en el paraíso tropical? Así lo mantienes perfecto.",
      note: "Te entregamos una guía detallada de cuidados después de tu sesión.",
      items: [
        { title: "Evita el sol directo", body: "Mantén tu tatuaje fuera del sol directo por 2–3 semanas." },
        { title: "Sin alberca, mar o cenotes", body: "Evita nadar 14 días para prevenir infecciones y desvanecimiento." },
        { title: "Hidrata a diario", body: "Aplica una capa fina de crema sin fragancia 2–3 veces al día." },
        { title: "No te rasques", body: "Deja que tu piel cicatrice naturalmente. La comezón es parte del proceso." },
        { title: "Ropa holgada", body: "Telas transpirables sobre el área ayudan a cicatrizar mejor." },
      ],
    },
    location: {
      eyebrow: "Encuéntranos",
      title: "Encuéntranos",
      sub: "En el corazón de Playa del Carmen, a poca distancia de la 5ta Avenida.",
      address: "Playa del Carmen, Quintana Roo, México",
      hours: "Lunes — Domingo · 10 a 00",
      directions: "Cómo llegar",
    },
    faq: {
      eyebrow: "Preguntas?",
      title: "Preguntas Frecuentes",
      items: [
        {
          q: "¿Es seguro tatuarse en México?",
          a: "Absolutamente. Seguimos estándares internacionales de higiene. Agujas de un solo uso, equipo esterilizado en autoclave y cumplimos los requisitos del departamento de salud.",
        },
        {
          q: "¿Hablan inglés?",
          a: "¡Sí! Nuestro equipo habla inglés y español. La comunicación nunca es un problema.",
        },
        {
          q: "¿Cómo reservo?",
          a: "Solo escríbenos por WhatsApp. Envíanos tu idea, imágenes de referencia y fechas. Nosotros nos encargamos del resto.",
        },
        {
          q: "¿Aceptan walk-ins?",
          a: "Sí, sujeto a disponibilidad. Para garantizar tu lugar, reserva antes por WhatsApp.",
        },
        {
          q: "¿Qué métodos de pago aceptan?",
          a: "Efectivo (MXN y USD), tarjeta de crédito y débito.",
        },
        {
          q: "¿Puedo reservar antes de mi viaje?",
          a: "Absolutamente — lo recomendamos. Reserva con tiempo y tendremos tu diseño listo cuando llegues.",
        },
        {
          q: "¿Y si quiero nadar después de tatuarme?",
          a: "Recomendamos evitar alberca, mar y cenotes por 14 días. Planea tu sesión idealmente al final de tu viaje.",
        },
        {
          q: "¿Hacen piercings y modificaciones corporales?",
          a: "Sí. Tyson es nuestro especialista con 8 años de experiencia en piercings, escarificación, implantes subdérmicos y más.",
        },
      ],
    },
    footer: {
      tagline: "Tatuajes personalizados, piercings y modificaciones corporales en Playa del Carmen.",
      quickLinks: "Explora",
      contact: "Contacto",
      hours: "Abierto 7 días · 10 a 00",
      rights: "Todos los derechos reservados.",
      builtBy: "Sitio por Elevyte",
      followArtists: "Sigue a los artistas",
    },
    mobile: { quote: "Cotizar", whatsapp: "WhatsApp" },
  },
};

export const getT = (lang) => translations[lang] || translations.en;
